import { useRef, useCallback } from 'react';
import { useReviewStore } from '../../../stores/review';

const CardBack = ({
  setFlipped,
  text,
  isActive = true,
}: {
  text?: string;
  setFlipped: (e: any) => void;
  isActive?: boolean;
}) => {
  const { currentFlashcard } = useReviewStore();
  const { back } = currentFlashcard || {};
  const textToShow = text || back;

  const scrollRef = useRef<HTMLDivElement>(null);
  const touchStartY = useRef(0);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    const el = scrollRef.current;
    if (!el) return;

    const deltaY = touchStartY.current - e.touches[0].clientY;
    touchStartY.current = e.touches[0].clientY;

    const isScrollable = el.scrollHeight > el.clientHeight;
    if (!isScrollable) return;

    const isAtTop = el.scrollTop <= 0 && deltaY < 0;
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight && deltaY > 0;

    if (!isAtTop && !isAtBottom) {
      e.stopPropagation();
    }

    el.scrollTop += deltaY;
  }, []);

  return (
    <div className={`text-white border shadow-xl absolute flex h-full w-full flex-col justify-between rounded-md border-hairline border-mono-color-dark bg-brand-color-primary-pure p-4 text-color-lightest [backface-visibility:hidden] [transform:rotateY(180deg)] ${!isActive ? 'pointer-events-none' : ''}`}>
      <div className=' flex h-full flex-col justify-between'>
        <div className='text-right'>
          <button
            onClick={() => setFlipped(false)}
            className='text-white text-sm font-semibold hover:underline dark:text-card-color-default'
          >
            Ver frente
          </button>
        </div>
        <div className='flex flex-1 items-center justify-center overflow-hidden'>
          <div
            ref={scrollRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            className='[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-transparent px-2 text-center text-lg font-semibold dark:text-card-color-default [&::-webkit-scrollbar-thumb]:bg-[#d1d5dc] [&::-webkit-scrollbar]:w-1 max-h-[140px] overflow-y-scroll [touch-action:pan-y]'
          >
            {textToShow}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CardBack;
